<template>
  <div class="contents buka-list">
    <h2>部課・就業場所一覧</h2>
    <div class="container">
      <div class="search">
        <h3>検索項目</h3>
        <form @submit.prevent="getList">
          <div class="search-container flex">
            <div class="item code">
              <b>部課コード</b>
              <input-text type="text" v-model="serchCondition.buka_code" class="input"></input-text>
            </div>

            <div class="item name">
              <b>部課名</b>
              <input-text type="text" v-model="serchCondition.buka_name"></input-text>
            </div>

            <div class="item kana">
              <b>部課名（カナ）</b>
              <input-text type="text" v-model="serchCondition.buka_kana"></input-text>
            </div>
          </div>

          <div class="btn-container">
            <button type="submit" class="btn primary" :disabled="isLoading">
              <i class="fa-solid fa-magnifying-glass"></i>検索
            </button>
          </div>
        </form>
      </div>

      <div class="col-item btn-container">
        <router-link :to="{ name: RouterConst.MST_BUKA_EDIT }" class="btn-link create"><i class="fa-solid fa-plus"></i>
          新規追加
        </router-link>
      </div>

      <loading v-if="isLoading"></loading>

      <div class="search-result" v-else-if="bukaList">
        <table class="list">
          <thead>
            <tr>
              <th class="syozoku" v-if="authStore.isAdmin">所属</th>
              <th class="code">部課コード</th>
              <th class="name">[部課ID] 部課名</th>
              <th class="syuugyou-basyo">就業場所名</th>
              <th class="control">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="buka in bukaList">
              <td class="syozoku" v-if="authStore.isAdmin">{{ buka.syozoku_name }}</td>
              <td class="code">{{ (buka.buka_code !== null && buka.buka_code !== '') ? buka.buka_code : '設定無し' }}</td>
              <td class="name">
                <router-link :to="{ name: RouterConst.MST_BUKA_EDIT, params: { bukaId: buka.mst_buka_id } }">[{{ buka.mst_buka_id }}] {{
                  buka.buka_name }}<br>（{{ buka.buka_kana }}）</router-link>
              </td>
              <td class="syuugyou-basyo">
                <ul>
                  <li v-for="syuugyouBasyo in buka.syuugyou_basyos">{{ syuugyouBasyo.syuugyou_basyo_name }}</li>
                </ul>
              </td>

              <td class="control">
                <button type="button" class="btn danger" v-on:click="deleteBukaConfirm(buka.mst_buka_id!)"><i
                    class="fa-solid fa-trash btn-edit"></i>削除</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="search-result" v-else>
        <p class="align-center">表示できる項目がありません</p>
      </div>
    </div>

    <div class="button-container">
      <p class="prev-page">
        <router-link :to="{
          name: RouterConst.MST_MENU,
        }">メニューに戻る
        </router-link>
      </p>
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent, onMounted, Ref, ref } from 'vue';
import { RouterConst } from '@/const/Router';
import { useRouter } from "vue-router";
import { useMstBukaInit } from '@/composable/buka/init';
import { useAuthStore } from '@/store/auth';
import { DialogService } from '@/service/DialogService';
import { useBukaDetail } from '@/composable/master/buka/buka';

export default defineComponent({
  setup() {
    const router = useRouter();

    const { bukaList, getBukaList, serchCondition } = useMstBukaInit();
    const { deleteBuka } = useBukaDetail();
    const isLoading = ref(true)
    const authStore = useAuthStore()

    onMounted(async () => {
      await getList()
    })

    const getList = async () => {
      isLoading.value = true
      await getBukaList(serchCondition.value)
      isLoading.value = false
    }

    const deleteBukaConfirm = async (bukaId: number) => {
      const dialogResult = await DialogService.warning({
        html: '部課を削除しますか？<br>なお、属している就業場所が雇用契約に紐づいている場合は削除できません。',
        showCancelButton: true,
        confirmButtonText: '削除する',
        cancelButtonText: 'キャンセル',
      })

      if (!dialogResult.isConfirmed) return

      if (await deleteBuka(bukaId)) {
        await getList()
      }
    }

    return {
      RouterConst,
      router,
      isLoading,
      serchCondition,
      getList,
      bukaList,
      authStore,
      deleteBukaConfirm
    }
  },
  components: {

  }
})
</script>

<style lang="scss" scoped>
@import "@scss/components/buka-search.scss";
</style>